import React from "react";
import "./request-financing-popup-mobile.style.less";
import { Button, Col, Modal, Row } from "antd";
import { withRouter } from "react-router-dom";

const RequestFinancingPopupMobile = ({ visible, setVisible, onUserClick }) => {
  return (
    <Modal
      visible={visible}
      title={null}
      footer={null}
      width="80%"
      centered
      onCancel={() => setVisible(false)}
      className="request-financing-popup-mobile"
    >
      <h1>Request Finance</h1>
      <Row className="user-wrapper" onClick={() => onUserClick("customer")}>
        <Col flex="24%" className="left-col">
          <img src="/images/Landing Page/As a Customer 2.svg" alt="Customer" />
        </Col>
        <Col flex="auto" />
        <Col flex="65%" className="right-col">
          <h3>
            As a{" "}
            <span>
              Customer{" "}
              <img
                className="right-icon"
                src={require("../../../../assets/logos/right_item.svg")}
              />
            </span>
          </h3>
          <p>
            Install Solar with the most Attractive finance options that increase
            your returns exponentially.
          </p>
        </Col>
      </Row>
      <Row className="user-wrapper" onClick={() => onUserClick("vendor")}>
        <Col flex="24%" className="left-col">
          <img src="/images/Landing Page/As a Vendor.svg" alt="Customer" />
        </Col>
        <Col flex="auto" />
        <Col flex="65%" className="right-col">
          <h3>
            As an{" "}
            <span>
              Execution Partner{" "}
              <img
                className="right-icon"
                src={require("../../../../assets/logos/right_item.svg")}
              />
            </span>
          </h3>
          <p>
            Grow your solar business by providing attractive financing options
            to your customers.
          </p>
        </Col>
      </Row>
      <div className="footer-wrapper">
        <Button className="cancel-btn" onClick={() => setVisible(false)}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default withRouter(RequestFinancingPopupMobile);
